<template>
  <div class="content">
    <div class="u-success">
      <img :src="imgUrlObj[platform][status]" alt="" />
    </div>
    <div class="t-success">
      {{ status == "nostart" ? "活动未开始！" : "报名已截止！" }}
    </div>
  </div>
</template>
<script>
export default {
  name: "FormStatus",
  props: {
    status: String,
    platform: String,
  },
  data() {
    return {
      imgUrlObj: {
        pc: {
          nostart: require("@/assets/images/pc/icon-no-start.png"),
          over: require("@/assets/images/pc/icon-over.png"),
        },
        wap: {
          nostart: require("@/assets/images/wap/icon-no-start.png"),
          over: require("@/assets/images/wap/icon-over.png"),
        },
      },
    };
  },
};
</script>
